import { Archive, Settings, Users } from "lucide-react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router";
import { DashboardSections } from "../../components/Dashboard";
import { auth } from "../../firebase";
import { ROUTES } from "../../routes/Routes";
import { useTranslation } from "react-i18next";
import { PageLayout } from "../../layout/PageLayout";

const Dashboard = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <PageLayout>
      <div className="grid grid-cols-3 gap-4 mt-8 height-[500px]">
        <DashboardSections
          icon={
            <Users
              size={32}
              className="text-indigo-500 bg-indigo-200 rounded-full p-3 h-16 w-16"
            />
          }
          title="Customer Base"
          callback={() => navigate(ROUTES.DPC)}
        />

        <DashboardSections
          icon={
            <Archive
              size={32}
              className="text-indigo-500 bg-indigo-200 rounded-full p-3 h-16 w-16"
            />
          }
          title="Product Base"
          callback={() => navigate(ROUTES.PRODUCTS)}
        />

        <DashboardSections
          icon={
            <Settings
              size={32}
              className="text-indigo-500 bg-indigo-200 rounded-full p-3 h-16 w-16"
            />
          }
          title="Settings"
          callback={() => navigate(ROUTES.SETTINGS)}
        />
      </div>
    </PageLayout>
  );
};

export default Dashboard;
